module.exports = __webpack_public_path__ + "img/title-1.647ae975.png";